var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * warning-triangle icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconWarningTriangle extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#3F3F3F"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 0C10.5704 0 10.1492 0.118551 9.78265 0.342598C9.41613 0.566645 9.11852 0.88748 8.92264 1.2698L0.249685 18.6156L0.24903 18.6169C0.0704306 18.9719 -0.0145864 19.3666 0.00204542 19.7636C0.0186976 20.1612 0.136694 20.5478 0.344829 20.8869C0.552964 21.226 0.844327 21.5063 1.19125 21.7011C1.53817 21.8959 1.92913 21.9988 2.32701 22L2.3293 22H19.6707L19.673 22C20.0709 21.9988 20.4618 21.8959 20.8088 21.7011C21.1557 21.5063 21.447 21.226 21.6552 20.8869C21.8633 20.5478 21.9813 20.1612 21.998 19.7636C22.0146 19.3666 21.9296 18.9719 21.751 18.617L21.7503 18.6156L13.0807 1.27643L13.0773 1.26982C12.8815 0.887497 12.5839 0.566645 12.2173 0.342598C11.8508 0.118551 11.4296 0 11 0ZM10.5729 1.63535C10.7015 1.55675 10.8493 1.51515 11 1.51515C11.1507 1.51515 11.2985 1.55675 11.4271 1.63535C11.5548 1.71341 11.6587 1.82497 11.7274 1.95788L20.3962 19.2953L20.3972 19.2974C20.4601 19.4221 20.49 19.5608 20.4841 19.7002C20.4783 19.8397 20.4369 19.9754 20.3639 20.0943C20.2908 20.2133 20.1886 20.3116 20.0669 20.38C19.9455 20.4482 19.8087 20.4842 19.6695 20.4848H2.33054C2.19131 20.4842 2.05452 20.4482 1.93311 20.38C1.81139 20.3116 1.70917 20.2133 1.63615 20.0943C1.56312 19.9754 1.52172 19.8397 1.51588 19.7002C1.51004 19.5608 1.53995 19.4221 1.60276 19.2974L1.60383 19.2953L10.2726 1.95788C10.3413 1.82497 10.4452 1.71341 10.5729 1.63535ZM11.7573 7.58611C11.7573 7.16772 11.4182 6.82854 10.9998 6.82854C10.5814 6.82854 10.2422 7.16772 10.2422 7.58611V12.3156C10.2422 12.734 10.5814 13.0731 10.9998 13.0731C11.4182 13.0731 11.7573 12.734 11.7573 12.3156V7.58611ZM9.48438 16.8585C9.48438 16.0217 10.1627 15.3434 10.9995 15.3434C11.8363 15.3434 12.5147 16.0217 12.5147 16.8585C12.5147 17.6953 11.8363 18.3737 10.9995 18.3737C10.1627 18.3737 9.48438 17.6953 9.48438 16.8585Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconWarningTriangle.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningTriangle.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningTriangle.prototype, "size", void 0);
if (customElements.get('cat-icon-warning-triangle') === undefined) {
    customElements.define('cat-icon-warning-triangle', BlocksIconWarningTriangle);
}
